'use client'

import { InfiniteFetch } from '@/core/ui/components/infinite-fetch'
import { usePostActions } from '@/features/blog/actions/client'
import { PostList } from '../post-list'
import { InfinitePostsSkeleton } from './skeleton'

export const InfinitePosts = () => {
  const { posts, loadMorePosts, loading } = usePostActions()

  return (
    <div className='space-y-4'>
      <InfiniteFetch onActive={loadMorePosts}>
        <PostList posts={posts} />
        {loading && <InfinitePostsSkeleton />}
      </InfiniteFetch>
    </div>
  )
}
